      <button
        class="sports-button--bet sports-button--bet-text background-color-button color-dark sports-button-custom"
        tappable
        (click)="onClick()"
      >
        {{ "SPO_betNow" | translate }}
        <i class="codere-icon icon-arrow-right"></i>
      </button>